import { api } from '@/utils/apis'

import { DepositRequestApiResponse, NetworkOption } from './types'

export const NETWORK_RENEC = 'RENEC Network'
export const renecNetworkOption: NetworkOption = {
  chain_name: NETWORK_RENEC,
  chain_name_abbr: NETWORK_RENEC,
  layer_name: '',
  layer_key: '',
}

export const generateDepositAddresses = async (publicKey: string, network: NetworkOption) => {
  try {
    const { data } = await api.get<DepositRequestApiResponse>('/deposit_addresses', {
      params: {
        layer: network.layer_key,
        address: publicKey,
      },
    })

    // Fake data to test on local
    // return {
    //   address: '0x57c65bc931c462d5c9a1f37cc278979e4abad309' + Date.now().toString(),
    //   layer: layerByNetworkMap[network],
    //   renec_wallet: publicKey,
    // }

    if (!data) throw new Error('')

    return data
  } catch (err) {
    return null
  }
}
